/*
包含一些常量值的模块
//  */

export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN // api base url 
export const ADMIN_DOMAIN = process.env.REACT_APP_ADMIN_DOMAIN // api base url (超管 -- 用于事件埋点)
export const API_OSS = process.env.REACT_APP_API_OSS // api 阿里oss
export const TEMPLATE_URL = process.env.REACT_APP_TEMPLATE_URL

//page speed
export const PAGE_DOMAIN = process.env.REACT_APP_PAGE_DOMAIN // api base url
export const PAGE_IMG_OSS_API = process.env.REACT_APP_IMG_OSS_API // api base url

//gmail账户所有者：魏浩
// export const REDIRECT_URI = 'https://app.seoant.com.com/auth/googleSearchConsoleAuth'//老版本url
// export const REDIRECT_URI = 'https://test-seomaster.giraffly.com/keywordRearch/GoogleSearchConsoleV2'
export const REDIRECT_URI = 'https://app.seoant.com/keywordRearch/GoogleSearchConsoleV2'
export const CLLIENT_ID   = process.env.REACT_APP_CLLIENT_ID
export const GOOGLLE_SEARCH_CONSOLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/auth?redirect_uri='+REDIRECT_URI+'&response_type=code&client_id='+CLLIENT_ID+'&scope=https://www.googleapis.com/auth/webmasters+https://www.googleapis.com/auth/webmasters.readonly+https://www.googleapis.com/auth/userinfo.email&approval_prompt=force&access_type=offline'; // google Search Console 授权请求地址    

// export const MIDDLE_INTEGRATION_API = "https://ztapi.trackingmore.com"; //测试
export const MIDDLE_INTEGRATION_API = "https://mpapi.channelwill.com";

export const CRISP_TOKEN = process.env.REACT_APP_CRISP_TOKEN

export const VITE_SHOPIFY_APP_KEY = process.env.REACT_APP_VITE_SHOPIFY_APP_KEY

// 默认选中/定位年版本(Annual)的国家白名单，其他国家默认月版本(Monthly)
// 取值对应 redux 中 shop_data.country 字段（国家英文全称）
export const ANNUAL_DEFAULT_COUNTRIES = [
    'United States',
    'France',
    'Germany',
    'Italy',
    'Canada',
    'United Kingdom',
    'Australia',
];

// 判断某个国家是否属于默认年版本(Annual)的白名单
export const isAnnualDefaultCountry = (country) => ANNUAL_DEFAULT_COUNTRIES.includes(country);
